import { render } from "./builder.vue?vue&type=template&id=81300c90&scoped=true"
import script from "./builder.vue?vue&type=script&lang=js"
export * from "./builder.vue?vue&type=script&lang=js"

import "./builder.vue?vue&type=style&index=0&id=81300c90&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81300c90"]])

export default __exports__